import React, { useState, useMemo } from 'react'
import CardList from 'component/cardList'

export default ({
  itemMinWidth = 375,
  loading,
  onInit,
  pageStart,
  pageSize,
  resultCount,
  data,
  renderCard,
  columnCount = 3
}) => {
  const [itemWidth, setItemWidth] = useState(itemMinWidth)

  const _itemWidth = itemMinWidth > itemWidth ? itemMinWidth : itemWidth

  const itemPadding = useMemo(() => {
    const _padding = itemWidth - itemMinWidth < 16 ? 16 : itemWidth - itemMinWidth
    if (_padding > 24) {
      return 24
    }
    return _padding
  }, [itemWidth])

  return <CardList
    pageSize={pageSize}
    pageStart={pageStart}
    resultCount={resultCount}
    loading={loading}
    onInit={onInit}
    columnCount={columnCount}
    itemMinWidth={itemMinWidth}
    setItemWidth={setItemWidth}
  >

    {data.map((dataItem) => renderCard({ data: dataItem, style: { padding: itemPadding }, innerWidth: _itemWidth - itemPadding }))}
  </CardList>
}
